import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useStyles } from './styles';

function CardHeaderRegular({ srcImg, question }) {
  const classes = useStyles();

  return (
    <Box className={classes.cardHeader}>
      <Box className={classes.imgContainer}>
        <img src={srcImg} alt="" className={classes.img} />
      </Box>
      <Typography className={classes.question}>{question}</Typography>
    </Box>
  );
}

export default CardHeaderRegular;
